<template>

  <div class="buttons">

    <router-link tag="button" to="/" class="button is-light">
        <b-icon pack="mdi" icon="file"></b-icon>
        <span>New build</span>
    </router-link>
    <button disabled="disabled" class="button is-light">
        <b-icon pack="mdi" icon="wrench"></b-icon>
        <span>Continue build</span>
    </button>

  </div>

</template>

<script>
    
  import { mapGetters, mapActions } from "vuex";

  export default {

    name: 'OrderNavigation',

    props: [],

    computed : {

    },

    methods:{
        ...mapActions(['userLogin'])

    },

    mounted(){

    }
 
  }
    
</script>

<style scoped>



</style>
